import { createFileRoute, redirect } from '@tanstack/react-router';
import { normalizeChapterSearchParam } from '../../../core/utils/chatUrl';
import { searchParamsValidator } from './-chatSearchParams';
import {
  getAssistantsQueryOptions,
  getDefaultModelQueryOptions,
} from '../../../features/marketplace/services/queries/assistantApiQueries';

export const Route = createFileRoute('/_app/chat')({
  validateSearch: searchParamsValidator,

  loaderDeps: ({ search }) => ({
    assistant: search.assistant,
    chapter: normalizeChapterSearchParam(search.chapter),
  }),
  loader: async ({ context, deps }) => {
    const assistantDetails = await context.queryClient.ensureQueryData(
      getAssistantsQueryOptions()
    );

    const defaultModelData = await context.queryClient.ensureQueryData(
      getDefaultModelQueryOptions()
    );
    // Check if assistant name is valid and present in the system
    // If the assistant doesn't exist, we redirect to /chat.
    const assistantMatch = assistantDetails.find(
      (a) => a.name === deps.assistant
    );

    if (deps.assistant && !assistantMatch) {
      // Redirect user to the main chat page with default assistant
      throw redirect({ to: '/chat', replace: true });
    }

    return {
      assistantDetails,
      defaultModelData,
      assistantFromUrl: assistantMatch ?? null,
      selectedChaptersFromUrl: deps.chapter,
    };
  },
});
